var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "retell-chat-test" },
    [
      _c(
        "div",
        { staticClass: "chat-header" },
        [
          _c(
            "a-button",
            {
              staticClass: "variables-button",
              attrs: { type: "default", disabled: _vm.isChatActive },
              on: { click: _vm.toggleVariablePopover },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("data_object"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("voiceagent.variables")))]),
            ]
          ),
          _vm._v(" "),
          !_vm.isChatActive
            ? _c(
                "a-button",
                {
                  staticClass: "start-button",
                  attrs: { type: "primary" },
                  on: { click: _vm.startChat },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("play_arrow"),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("voiceagent.startChat")) +
                      "\n        "
                  ),
                ]
              )
            : _c(
                "a-button",
                {
                  staticClass: "end-button",
                  attrs: { type: "danger" },
                  on: { click: _vm.endChat },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("stop")]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("voiceagent.endChat")) +
                      "\n        "
                  ),
                ]
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-popover",
        {
          attrs: {
            title: _vm.$t("voiceagent.customVariableValues"),
            trigger: "click",
            placement: "bottomLeft",
            overlayClassName: "variable-values-popover",
          },
          model: {
            value: _vm.variablePopoverVisible,
            callback: function ($$v) {
              _vm.variablePopoverVisible = $$v
            },
            expression: "variablePopoverVisible",
          },
        },
        [
          _c("template", { slot: "content" }, [
            _vm.extractedVariables.length === 0
              ? _c("div", { staticClass: "no-variables" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("voiceagent.promptNoVariablesHint")) +
                      "\n            "
                  ),
                ])
              : _c(
                  "div",
                  { staticClass: "variable-values-form" },
                  [
                    _vm._l(_vm.extractedVariables, function (variable, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "variable-row" },
                        [
                          _c("span", { staticClass: "variable-name" }, [
                            _vm._v(_vm._s(variable.name) + ":"),
                          ]),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.$t("voiceagent.enterValue"),
                              disabled: _vm.isChatActive,
                            },
                            model: {
                              value: variable.value,
                              callback: function ($$v) {
                                _vm.$set(variable, "value", $$v)
                              },
                              expression: "variable.value",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: _vm.isChatActive,
                            },
                            on: { click: _vm.saveVariableValues },
                          },
                          [_vm._v(_vm._s(_vm.$t("voiceagent.save")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.chatStatus
        ? _c("div", { staticClass: "chat-status" }, [
            _c(
              "span",
              {
                class: {
                  "status-active": _vm.isChatActive,
                  "status-ended": _vm.chatStatus === "ended",
                },
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.chatStatusText) + "\n        "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "messagesContainer", staticClass: "messages-container" },
        [
          _vm.messages.length === 0 && !_vm.isChatActive
            ? _c("div", { staticClass: "empty-chat" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("chat_bubble_outline"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("voiceagent.testLlmByStartingChat"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.messages, function (message, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "message-item",
                class: _vm.getMessageClass(message),
              },
              [
                message.role === "knowledge_base_retrieval"
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "kb-retrieval-item",
                          on: {
                            click: function ($event) {
                              return _vm.showKnowledgeBaseModal(
                                message._knowledgeBaseContent
                              )
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("search"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("voiceagent.knowledgeBaseRetrieval")
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  : message.role === "agent" || message.role === "user"
                  ? [
                      _c("div", { staticClass: "message-header" }, [
                        _c("span", { staticClass: "role-label" }, [
                          _vm._v(
                            _vm._s(
                              message.role === "agent"
                                ? _vm.$t("voiceagent.agent")
                                : _vm.$t("voiceagent.user")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "timestamp" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatTimestamp(message.created_timestamp)
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "message-content" }, [
                        _vm._v(_vm._s(message.content)),
                      ]),
                      _vm._v(" "),
                      message.role === "user"
                        ? _c(
                            "a-button",
                            {
                              staticClass: "delete-message-btn",
                              attrs: {
                                type: "link",
                                size: "small",
                                disabled: _vm.isWaitingResponse,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteMessage(index)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : message.role === "tool_call_invocation"
                  ? [
                      _c(
                        "a-collapse",
                        { staticClass: "tool-collapse" },
                        [
                          _c(
                            "a-collapse-panel",
                            [
                              _c("template", { slot: "header" }, [
                                _c("div", { staticClass: "tool-header" }, [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("build"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("voiceagent.toolInvocation")
                                      ) +
                                        ": " +
                                        _vm._s(message.name)
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "tool-details" }, [
                                _c("div", { staticClass: "tool-row" }, [
                                  _c("span", { staticClass: "tool-label" }, [
                                    _vm._v("tool_call_id:"),
                                  ]),
                                  _vm._v(" "),
                                  _c("code", [
                                    _vm._v(_vm._s(message.tool_call_id)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "tool-row" }, [
                                  _c("span", { staticClass: "tool-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("voiceagent.argumentsLabel")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("pre", { staticClass: "tool-args-pre" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatToolArguments(
                                          message.arguments
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  : message.role === "tool_call_result"
                  ? [
                      _c(
                        "a-collapse",
                        { staticClass: "tool-collapse tool-result-collapse" },
                        [
                          _c(
                            "a-collapse-panel",
                            [
                              _c("template", { slot: "header" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tool-header tool-result-header",
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("check_circle"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("voiceagent.toolResult"))
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "tool-details" }, [
                                _c("div", { staticClass: "tool-row" }, [
                                  _c("span", { staticClass: "tool-label" }, [
                                    _vm._v("tool_call_id:"),
                                  ]),
                                  _vm._v(" "),
                                  _c("code", [
                                    _vm._v(_vm._s(message.tool_call_id)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "tool-row" }, [
                                  _c("span", { staticClass: "tool-label" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("voiceagent.resultLabel"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "pre",
                                    { staticClass: "tool-result-pre" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatToolResult(message.content)
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  : message.role === "node_transition"
                  ? [
                      _c("div", { staticClass: "message-header" }, [
                        _c("span", { staticClass: "role-label" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("swap_horiz"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("voiceagent.nodeTransition"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "timestamp" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatTimestamp(message.created_timestamp)
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "message-content transition-content" },
                        [
                          _c("span", { staticClass: "from-state" }, [
                            _vm._v(
                              _vm._s(
                                message.former_node_name ||
                                  message.former_node_id ||
                                  "-"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("arrow_forward"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "to-state" }, [
                            _vm._v(
                              _vm._s(
                                message.new_node_name ||
                                  message.new_node_id ||
                                  "-"
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  : message.role === "state_transition"
                  ? [
                      _c("div", { staticClass: "message-header" }, [
                        _c("span", { staticClass: "role-label" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("swap_vert"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("voiceagent.stateTransition"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "timestamp" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatTimestamp(message.created_timestamp)
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "message-content transition-content" },
                        [
                          _c("span", { staticClass: "from-state" }, [
                            _vm._v(_vm._s(message.former_state_name || "-")),
                          ]),
                          _vm._v(" "),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("arrow_forward"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "to-state" }, [
                            _vm._v(_vm._s(message.new_state_name || "-")),
                          ]),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm.isWaitingResponse
            ? _c(
                "div",
                { staticClass: "message-item agent typing-indicator" },
                [_vm._m(0)]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isChatActive
        ? _c(
            "div",
            { staticClass: "message-input-container" },
            [
              _c(
                "a-button",
                {
                  staticClass: "reset-btn",
                  attrs: {
                    type: "default",
                    disabled:
                      _vm.isWaitingResponse || _vm.messages.length === 0,
                    title: _vm.$t("voiceagent.resetTitle"),
                  },
                  on: { click: _vm.resetChat },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("refresh"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("a-input", {
                ref: "messageInput",
                attrs: {
                  placeholder: _vm.$t("voiceagent.typeYourMessage"),
                  disabled: _vm.isWaitingResponse,
                },
                on: { pressEnter: _vm.sendMessage },
                model: {
                  value: _vm.messageInput,
                  callback: function ($$v) {
                    _vm.messageInput = $$v
                  },
                  expression: "messageInput",
                },
              }),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: !_vm.messageInput.trim() || _vm.isWaitingResponse,
                    loading: _vm.isWaitingResponse,
                  },
                  on: { click: _vm.sendMessage },
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("send")])]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "kb-modal",
          attrs: {
            title: _vm.$t("voiceagent.kbModalTitle"),
            footer: null,
            width: "700px",
          },
          model: {
            value: _vm.knowledgeBaseModalVisible,
            callback: function ($$v) {
              _vm.knowledgeBaseModalVisible = $$v
            },
            expression: "knowledgeBaseModalVisible",
          },
        },
        [
          _vm.currentKnowledgeBaseContent &&
          _vm.currentKnowledgeBaseContent.length > 0
            ? _c(
                "div",
                { staticClass: "kb-content-list" },
                _vm._l(
                  _vm.currentKnowledgeBaseContent,
                  function (chunk, chunkIndex) {
                    return _c(
                      "div",
                      { key: chunkIndex, staticClass: "kb-chunk" },
                      [
                        _c("div", { staticClass: "kb-chunk-header" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("voiceagent.chunkLabel", {
                                n: chunkIndex + 1,
                              })
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "kb-chunk-content" }, [
                          _vm._v(_vm._s(chunk)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            staticClass: "expand-btn",
                            attrs: { type: "link", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleChunkExpand(chunkIndex)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.expandedChunks[chunkIndex]
                                    ? _vm.$t("voiceagent.collapse")
                                    : _vm.$t("voiceagent.expand")
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  }
                ),
                0
              )
            : _c("div", { staticClass: "kb-empty" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("voiceagent.kbContentNotFound")) +
                    "\n        "
                ),
              ]),
        ]
      ),
      _vm._v(" "),
      !_vm.isChatActive && _vm.logs.length > 0
        ? _c("div", { staticClass: "test-logs" }, [
            _c("h4", [_vm._v(_vm._s(_vm.$t("voiceagent.logSectionTitle")))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "log-entries" },
              _vm._l(_vm.logs, function (logEntry, index) {
                return _c("div", { key: index, staticClass: "log-entry" }, [
                  _vm._v(
                    "\n                " + _vm._s(logEntry) + "\n            "
                  ),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "typing-dots" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }